import { useMemo } from 'react';
import { FormsSubmission } from '@frontend/api-forms';
// Use the narrow nav-constants entry, not the @frontend/forms barrel. Global nav renders at
// startup, and the barrel drags the whole forms feature (builder, kiosk, library, etc.) into boot.
import {
  routes as formRoutes,
  routeUtils as formRouteUtils,
  pendoTags as formsPendoTags,
} from '@frontend/forms-nav-constants';
import { useTranslation } from '@frontend/i18n';
import { createNavItem, createSubNavItems } from '../nav-item-utils';
import { featureDefinition as formsFeatureDefinition } from './feature-definitions';

export const useFormsNavItem = () => {
  const { t } = useTranslation('primaryNav');
  const formsSubmissionCount = FormsSubmission.useSubmissionsUnreadCount();
  const formsItems = formsFeatureDefinition.items;

  const subNavItems = useMemo(
    () =>
      createSubNavItems([
        {
          ...formsItems['/submissions'],
          count: formsSubmissionCount.data?.count,
          label: t('Submissions'),
          relativePath: '/submissions',
          path: `/forms${formRouteUtils.getRoutePathAsString(
            formRoutes.submissionsV2.goTo({ listType: 'inbox', subCategory: 'all', relativePath: true })
          )}`,
          trackingId: formsPendoTags.sideNav.submissions,
        },
        {
          ...formsItems['/library'],
          label: t('My Forms'),
          relativePath: '/library',
          path: `/forms${formRouteUtils.getRoutePathAsString(formRoutes.library.formsV2({ relativePath: true }))}`,
          trackingId: formsPendoTags.sideNav.myForms,
        },
        {
          ...formsItems['/kiosk'],
          label: t('Kiosk Mode'),
          relativePath: '/kiosk',
          trackingId: formsPendoTags.sideNav.kiosk,
        },
        {
          ...formsItems['/templates'],
          label: t('Templates'),
          relativePath: '/templates',
          path: `/forms${formRouteUtils.getRoutePathAsString(
            formRoutes.templates.templatesList({ relativePath: true })
          )}`,
          trackingId: formsPendoTags.sideNav.templates,
        },
        {
          ...formsItems['/builder/new'],
          label: t('Builder'),
          relativePath: '/builder/new',
          trackingId: formsPendoTags.sideNav.builder,
        },
        {
          ...formsItems['/digitization'],
          label: t('Request Digitization'),
          relativePath: '/digitization',
          trackingId: formsPendoTags.sideNav.requestDigitization,
        },
      ]),
    [t, formsSubmissionCount.data?.count, formsItems]
  );

  return useMemo(
    () =>
      createNavItem('forms', {
        hasCount: !!formsSubmissionCount.data?.count,
        iconName: 'forms',
        label: t('Forms'),
        root: '/forms',
        subNavItems,
        settings: { path: '/digital-forms', label: '', show: true },
      }),
    [t, formsSubmissionCount.data?.count, subNavItems]
  );
};
